import http from "@/settings/apiSettings"

class OrganigramaService {
    save(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/RU_Organigrama", data)
    }

    saveDetalii(data: any) : Promise<any> {
        return http.clientResurseUmaneOdata.post("/RU_OrganigramaDetalii", data)
    }
}
export default new OrganigramaService()